import { createClient } from "@supabase/supabase-js";
import { Database } from "../types/supabase";

export const supabaseClient = createClient<Database>(
  "https://asoxejhdhcxxpkcfrbys.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFzb3hlamhkaGN4eHBrY2ZyYnlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODI1MDU2NDcsImV4cCI6MTk5ODA4MTY0N30.klQT3w2uJt8o3KMzIXDUXFL2SeDwL8X0DFR6l5TI-wI"
);
